import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    chart: {
        height: '336px',
    },
}));
